"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _styled = require("./styled");

var MessageStatusLikes = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(MessageStatusLikes, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(MessageStatusLikes);

  function MessageStatusLikes() {
    (0, _classCallCheck2["default"])(this, MessageStatusLikes);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MessageStatusLikes, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          likesString = _this$props.likesString,
          size = _this$props.size,
          showIcon = _this$props.showIcon,
          liked = _this$props.liked,
          onLike = _this$props.onLike,
          onHover = _this$props.onHover,
          likers = _this$props.likers,
          numberOfShownLikers = _this$props.numberOfShownLikers,
          canHover = _this$props.canHover;
      var icon = liked ? /*#__PURE__*/_react["default"].createElement(_styled.LikedIcon, {
        color: "primary",
        fontSize: "inherit"
      }) : /*#__PURE__*/_react["default"].createElement(_styled.LikeIcon, {
        fontSize: "inherit"
      });

      var content = function content(ref) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: ref
        }, /*#__PURE__*/_react["default"].createElement(_styled.Wrapper, {
          container: true,
          onClick: onLike,
          wrap: "nowrap",
          alignItems: "center"
        }, /*#__PURE__*/_react["default"].createElement(_styled.LikeWrapperTypography, {
          variant: size === 'small' ? 'caption' : 'body2'
        }, showIcon && icon, likesString)));
      };

      return canHover ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        content: likers ? /*#__PURE__*/_react["default"].createElement(_styled.Likers, null, likers.slice(0, numberOfShownLikers).map(function (liker) {
          return /*#__PURE__*/_react["default"].createElement(_styled.LikerTypography, {
            key: liker.name
          }, liker.name);
        }), likers.length > numberOfShownLikers && /*#__PURE__*/_react["default"].createElement(_styled.LikerTypography, null, "+".concat(likers.length - numberOfShownLikers))) : /*#__PURE__*/_react["default"].createElement(_styled.LikerTypography, null, "Loading"),
        placement: "top",
        onShow: onHover
      }, function (childrenRef) {
        return content(childrenRef);
      }) : content(null);
    }
  }]);
  return MessageStatusLikes;
}(_react["default"].PureComponent);

MessageStatusLikes.defaultProps = {
  liked: false,
  size: 'normal',
  onLike: null,
  showIcon: false,
  likers: null,
  numberOfShownLikers: 5
};
var _default = MessageStatusLikes;
exports["default"] = _default;